var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#ECF7F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 22C27 21.45 27.45 21 28 21C28.55 21 29 21.45 29 22C29 22.55 28.55 23 28 23C27.45 23 27 22.55 27 22ZM20 21H25V19H20V21ZM34 19.5V26.47L31.18 27.41L29.5 33H24V31H22V33H16.5C16.5 33 14 24.54 14 21.5C14 18.46 16.46 16 19.5 16H24.5C25.41 14.79 26.86 14 28.5 14C29.33 14 30 14.67 30 15.5C30 15.71 29.96 15.9 29.88 16.08C29.74 16.42 29.62 16.81 29.56 17.23L31.83 19.5H34ZM32 21.5H31L27.5 18C27.5 17.35 27.59 16.71 27.76 16.09C26.79 16.34 26 17.06 25.67 18H19.5C17.57 18 16 19.57 16 21.5C16 23.38 17.22 28.15 18.01 31H20V29H26V31H28.01L29.56 25.85L32 25.03V21.5Z",
    fill: "#009248"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/saving.4eaf33f6374ccd15c36a600c22012707.svg";
export { ForwardRef as ReactComponent };